<template>
  <pt-scan-payment-table ref="table" :tableLabels="tableLabels" :tableData="tableData" :totalNumber="totalNumber"  @getDepositSettlementList="getDepositSettlementList" v-loading="loading" class="pt-scan-payment-table__withData">
    <slot/>
  </pt-scan-payment-table>
</template>

<script>
import PtScanPaymnetTable from './index'
import { tableLabels } from '../scan-payment'
export default {
  name: 'pt-scan-payment-table__withData',
  components: {
    'pt-scan-payment-table': PtScanPaymnetTable
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      totalNumber: 0,
      tableData: [],
      page: '',
      tableLabels: tableLabels
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        this.getDepositSettlementList(0)
      },
      deep: true
    }
  },
  methods: {
    getDepositSettlementList (page, next, size) {
      let data = {
        ...this.paramsData,
        pageable: {
          page: page,
          size: size || this.pageSize
        },
        sourceServiceTag: 'lifebank-cps'
      }
      this.page = page
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getScanPaymentList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取订金结算失败')
      })
    }
  }
}
</script>
